module.exports = __webpack_public_path__ + "static/img/products application_Tape PVC2.9078e481.jpg";